import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Admin} from '../../../admin/admin';
import {Observable} from 'rxjs';
import {AdminService} from '../../../admin/admin.service';
import {map, mergeMap} from 'rxjs/operators';

@Component({
    templateUrl: './admin.page.html',
    styleUrls: ['./admin.page.scss'],
    standalone: false
})
export class AdminPage implements OnInit {
  private adminService = inject(AdminService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  admin$: Observable<Admin>;

  ngOnInit(): void {
    this.admin$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.adminService.getAdminById$(id)),
      );
  }

  onCancelClicked(): void {
    this.navigateToAdmins();
  }

  onEditClicked(admin: Admin): void {
    this.adminService.updateAdmin$(admin)
      .subscribe(() => this.navigateToAdmins());
  }

  private navigateToAdmins(): void {
    this.router.navigateByUrl('/admins');
  }
}
